import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import { MdClose } from 'react-icons/md';
import { toast } from 'react-toastify';
import { createClassEvent } from '../../services/apiService';

function CreateEventModal({ open, onClose, allCohorts }) {
  const [eventName, setEventName] = useState('');
  const [moduleName, setModuleName] = useState('');
  const [moduleId, setModuleId] = useState('');
  const [selectedCohorts, setSelectedCohorts] = useState([]);

  const inputStyle = {
    width: '100%',
    border: '1px solid #E5E7EB',
    borderRadius: 4,
    padding: '8px 12px',
    fontSize: 13,
    color: '#111827',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 600,
    color: '#374151',
    marginBottom: 4,
    display: 'block',
  };

  const handleClear = () => {
    setEventName('');
    setModuleName('');
    setModuleId('');
    setSelectedCohorts([]);
  };

  const handleSubmit = async () => {
    try {
      await createClassEvent({
        eventName,
        moduleName,
        moduleId,
        cohorts: selectedCohorts,
      });
      toast.success('Event created successfully');
      handleClear();
      onClose();
    } catch {
      toast.error('Failed to create event');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 20px',
          borderBottom: '1px solid #F3F4F6',
        }}
      >
        <span style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>
          Create New Event
        </span>
        <button
          onClick={onClose}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6B7280', padding: 0 }}
        >
          <MdClose size={20} />
        </button>
      </div>
      <DialogContent style={{ padding: '20px' }}>
        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Event Name</label>
            <input
              style={inputStyle}
              value={eventName}
              onChange={(e) => setEventName(e.target.value)}
              placeholder="Enter event name"
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Module Name</label>
            <input
              style={inputStyle}
              value={moduleName}
              onChange={(e) => setModuleName(e.target.value)}
              placeholder="Enter module name"
            />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Module ID</label>
            <input
              style={inputStyle}
              value={moduleId}
              onChange={(e) => setModuleId(e.target.value)}
              placeholder="Enter module ID"
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Cohort Name</label>
            <Autocomplete
              multiple
              options={(allCohorts || []).map((c) => c.cohortName || c.name)}
              value={selectedCohorts}
              onChange={(_, val) => setSelectedCohorts(val)}
              disableCloseOnSelect
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    key={option}
                    label={option}
                    size="small"
                    {...getTagProps({ index })}
                    style={{
                      backgroundColor: '#EEF2FF',
                      color: '#4F46E5',
                      fontWeight: 600,
                      fontSize: 11.5,
                      borderRadius: 4,
                      border: 'none',
                      height: 24,
                    }}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={selectedCohorts.length === 0 ? 'Search cohort...' : ''}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      fontSize: 13,
                      fontFamily: "'Gellix', 'Inter', sans-serif",
                      borderRadius: 4,
                      backgroundColor: '#fff',
                      padding: '2px 8px',
                    },
                  }}
                />
              )}
              ListboxProps={{
                style: { fontSize: 13, fontFamily: "'Gellix', 'Inter', sans-serif" },
              }}
            />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
          <button
            onClick={handleClear}
            style={{
              border: '1px solid #E5E7EB',
              background: '#fff',
              color: '#374151',
              borderRadius: 4,
              padding: '8px 20px',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Clear
          </button>
          <button
            onClick={handleSubmit}
            style={{
              border: 'none',
              background: '#4F46E5',
              color: '#fff',
              borderRadius: 4,
              padding: '8px 20px',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Create Event
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CreateEventModal;
